
import dict from "@/config"
export const getStatisticsColumns = () => {
    return [
        {
            title: "统计周期",
            dataIndex: "frequency",
            align: "center",
            customRender: (text) => {
                return dict.FREQUENCY_MAP[text] || "--";
            },
        },
        {
            title: "老师发布数",
            dataIndex: "teacher_count",
            align: "center",
            customRender: (text) => {
                return text || 0;
            },
        },
        {
            title: "家长发布数",
            dataIndex: "kinsfolk_count",
            align: "center",
            customRender: (text) => {
                return text || 0;
            },
        },
        {
            title: "发布总数",
            dataIndex: "total_count",
            align: "center",
            customRender: (text) => {
                return text || 0;
            },
        },
    ];
};

export const getKlassesStatisticsColumns = () => {
    return [
        {
            title: "班级",
            dataIndex: "klass_name",
            align: "center",
            customRender: (text) => {
                return text || "--";
            },
        },
        {
            title: "今日",
            children: [
                {
                    title: "老师发布数",
                    dataIndex: "daily_teacher_count",
                },
                {
                    title: "家长发布数",
                    dataIndex: "daily_kinsfolk_count",
                },
                {
                    title: "发布总数",
                    dataIndex: "daily_total_count",
                },
            ],
        },
        {
            title: "本周",
            children: [
                {
                    title: "老师发布数",
                    dataIndex: "weekly_teacher_count",
                },
                {
                    title: "家长发布数",
                    dataIndex: "weekly_kinsfolk_count",
                },
                {
                    title: "发布总数",
                    dataIndex: "weekly_total_count",
                },
            ],
        },
        {
            title: "本月",
            children: [
                {
                    title: "老师发布数",
                    dataIndex: "monthly_teacher_count",
                },
                {
                    title: "家长发布数",
                    dataIndex: "monthly_kinsfolk_count",
                },
                {
                    title: "发布总数",
                    dataIndex: "monthly_total_count",
                },
            ],
        },
    ];
};
export default {
    getStatisticsColumns
};
